/**
 * Header Search — expand/collapse
 *
 * Click search icon → expand input → type → submit or collapse.
 * Mirrors legacy purso theme UX with accessibility.
 */

function initHeaderSearch( form ) {
	const toggle = form.querySelector( '.js-search-toggle' );
	const input = form.querySelector( '.site-search-form__input' );

	if ( ! toggle || ! input ) {
		return;
	}

	function expand() {
		form.setAttribute( 'aria-expanded', 'true' );
		form.classList.add( 'is-expanded' );
		input.focus();
	}

	function collapse() {
		form.setAttribute( 'aria-expanded', 'false' );
		form.classList.remove( 'is-expanded' );
		input.value = '';
	}

	function isExpanded() {
		return form.classList.contains( 'is-expanded' );
	}

	toggle.addEventListener( 'click', function ( e ) {
		if ( ! isExpanded() ) {
			// First click: expand and show input.
			e.preventDefault();
			expand();
		} else if ( ! input.value.trim() ) {
			// Expanded but empty: collapse.
			e.preventDefault();
			collapse();
		}
		// Expanded with value: default submit proceeds.
	} );

	input.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' ) {
			e.preventDefault();
			collapse();
			toggle.focus();
		}
	} );

	// Close when clicking outside the form.
	document.addEventListener( 'click', function ( e ) {
		if ( isExpanded() && ! form.contains( e.target ) ) {
			collapse();
		}
	} );
}

function init() {
	const forms = document.querySelectorAll( '.js-header-search' );
	for ( const form of forms ) {
		initHeaderSearch( form );
	}
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
